module.exports = __webpack_public_path__ + "media/images/logo-black-small-0bc2581c3f4193c2d60969fc6bb6fec9.png";